import { useQuery } from "@grandvisionhq/graphql";
import { GET_ESTIMATED_DELIVERY_BY_SKUS } from "../../operations/queries/operations/queries/get-estimated-delivery-by-skus.js";
const useGetDispatchDate = (items, shippingMethodKey) => {
  const { data, loading, error } = useQuery(GET_ESTIMATED_DELIVERY_BY_SKUS, {
    variables: {
      input: {
        skuQuantityPairs: items,
        shippingMethodKey
      }
    },
    skip: !items || !Array.isArray(items) || !items.length
  });
  const dispatchDate = data?.estimatedDeliveryBySkus?.shippingDate;
  if (error) {
    console.error(error);
  }
  return { dispatchDate, loading, error };
};
export {
  useGetDispatchDate
};
//# sourceMappingURL=use-get-dispatch-date.js.map
